/**
 * Playready Recommendation Key System.
 *
 *
 * @beta
 */
export const PLAYREADY_RECOMMENDATION_KEY_SYSTEM = 'com.microsoft.playready.recommendation'
